export default __webpack_public_path__ + "static/media/ch_0.2c2b80c1.mp3";